import { jsPDF } from "jspdf";
import "jspdf-autotable";
import moment from "moment";

const getHours = (hrs) => {
  const roundedTotalHours = Math.round(hrs * 100) / 100;

  const hours = Math.floor(roundedTotalHours);
  const minutes = Math.round((roundedTotalHours % 1) * 60);

  const totalString = `${hours}:${minutes.toString().padStart(2, "0")}`;

  return totalString;
};

function convertDecimalToTime(decimalValue = 0) {
  let hours = Math.floor(decimalValue);
  const minutes = (decimalValue - hours) * 60;
  if (hours < 10) {
    hours = `0${hours}`;
  }
  let min = Math.round(minutes);
  if (min < 10) {
    min = `0${min}`;
  }
  return `${hours}:${min}`;
}

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const convertToPDF = async (data, typeD) => {
  await delay(1000);
  let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
  // let selectedProject = localStorage.getItem("projectForPrint");
  //   let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
  let selectedClientName = localStorage.getItem("clientNameForPrint");
  let employeeName = localStorage.getItem("firstname");

  let pdfTitle = `${selectedClientName}-Worktime Report,-${workspaceName}-${moment(
    new Date()
  ).format("YYYY.MM.DD, h:mm a")}.pdf`;

  if (typeD === "worktime") {
    const pdfDoc = new jsPDF();

    // pdfDoc.text(`User: ${user.firstName} ${user.lastName}`, 10, 10);

    let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
    // let selectedProject = localStorage.getItem("projectForPrint");
    // let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
    let selectedClientName = localStorage.getItem("clientNameForPrint");
    let employeeName = localStorage.getItem("firstname");

    let pdfTitle2 = `${employeeName}-Time Tracking Report,-${workspaceName}-${moment(
      new Date()
    ).format("YYYY.MM.DD, h:mm a")}.pdf`;

    pdfDoc.autoTable({
      startY: 20,
      head: [
        [
          "Project Name",
          "Task Name",
          "Start Date",
          "Start Time",
          "End Date",
          "End Time",
          "Total Hours",
          "Type",
          "Description",
        ],
      ],
      body: data.map((task) => [
        task.projectName,
        task.taskName,
        task.trackerStartDate,
        task.trackerStartTime,
        task.trackerEndDate,
        task.trackerEndTime,
        convertDecimalToTime(task.totalHours),
        task.type,
        task.description,
        task.isApproved,
      ]),
      styles: { fontSize: 8 },
    });

    // pdfDoc.save('tasks.pdf');
    pdfDoc.save(pdfTitle2);
    return;
  }

  const pdfDoc = new jsPDF();

  data.forEach((user, index) => {
    if (index > 0) {
      pdfDoc.addPage();
    }

    pdfDoc.text(`User: ${user.firstName} ${user.lastName}`, 10, 10);

    pdfDoc.autoTable({
      startY: 20,
      head: [
        [
          "Project Name",
          "Task Name",
          "Start Date",
          "Start Time",
          "End Date",
          "End Time",
          "Total Hours",
          "Type",
          "Description",
          "Is Approved",
        ],
      ],
      body: user.dateWiseTasksList.flatMap((tasks) =>
        tasks.map((task) => [
          task.projectName,
          task.taskName,
          task.trackerStartDate,
          task.trackerStartTime,
          task.trackerEndDate,
          task.trackerEndTime,
          getHours(task.totalHours),
          task.type,
          task.description,
          task.isApproved,
        ])
      ),
      styles: { fontSize: 8 },
    });
  });

  //   pdfDoc.save("tasks.pdf");
  pdfDoc.save(pdfTitle);
};

export { convertToPDF };
